//const Backofficebff         : string = "/backofficebff/service/api/v1";
//const BackofficebffV2         : string = "/backofficebff/service/api/v2";
const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const MobilePanelClientTranslationsCommand: any = {
    RemoveMobilePanelClientTranslation: Backofficebff + '/v1/mobilepanelclienttranslations/delete-client-translation',
    UpdateMobilePanelClientTranslation: Backofficebff + '/v1/mobilepanelclienttranslations/update-client-translation',
    CreateMobilePanelClientTranslation: Backofficebff + '/v1/mobilepanelclienttranslations/create-client-translation',
    BulkUploadMobilePanelClientTranslations: Backofficebff + '/v1/mobilepanelclienttranslations/bulk-upload-client-translations',
};
